(() => {
  'use strict';
  const dialog = document.querySelector('[data-privacy-dialog]');
  if (!dialog) return;
  const form = dialog.querySelector('[data-privacy-form]');
  const fields = dialog.querySelector('[data-privacy-fields]');
  const status = dialog.querySelector('[data-privacy-status]');
  const purposes = ['preferences', 'analytics', 'marketing'];
  let origin;
  let apiPromise;
  const loadAPI = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!apiPromise) apiPromise = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) return reject(new Error('unavailable'));
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (error || !window.Shopify.customerPrivacy) reject(new Error('unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch(error => {apiPromise = null; throw error;});
    return apiPromise;
  };
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-cookie-settings]');
    if (!link || !dialog.showModal) return;
    event.preventDefault();
    origin = link;
    if (window.privacyBanner?.showPreferences) {
      try {await window.privacyBanner.showPreferences(); return;} catch (_) { /* use the accessible fallback */ }
    }
    if (!dialog.open) dialog.showModal();
    fields.disabled = true;
    status.textContent = 'Loading your preferences…';
    try {
      const api = await loadAPI();
      const consent = api.currentVisitorConsent();
      purposes.forEach(purpose => {form.elements[purpose].checked = consent[purpose] === 'yes';});
      fields.disabled = false;
      status.textContent = '';
    } catch (_) {
      status.textContent = 'Preferences could not load. Please close this window and try again, or visit Your Privacy Choices below.';
    }
  });
  dialog.querySelector('[data-privacy-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => origin?.focus());
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (fields.disabled) return;
    const consent = Object.fromEntries(purposes.map(purpose => [purpose, form.elements[purpose].checked]));
    fields.disabled = true;
    status.textContent = 'Saving…';
    try {
      const api = await loadAPI();
      await new Promise((resolve, reject) => api.setTrackingConsent(consent, result => result?.error ? reject(new Error(result.error)) : resolve()));
      dialog.close();
    } catch (_) {
      status.textContent = 'Your choices could not be saved. Please try again.';
    } finally {fields.disabled = false;}
  });
})();
